module.exports = __webpack_public_path__ + "img/google-play-badge.4263a06f.png";